import { ReactElement, useEffect, useState } from 'react';
import { MailIcon } from '../../../../assets/icons';
import { SelectableCard } from '../../../../core/components';
import { tokens } from '../../../../core/theme';
import { RequestType } from '../../../../core/types';
import { FaqContent, faqContent } from '../../utils/faqContent';

const CONTACT_CARD_REQUEST_TYPE: RequestType = 'informacao';

const CONTACT_CARD_CONTENT: FaqContent = {
  card: {
    title: 'Envie sua Dúvida',
    icon: MailIcon,
    description: 'Não achou o que precisa? Fale com a gente.',
  },
  sections: [],
};

type FaqMenuProps = {
  onSelectTopic: (content: FaqContent) => void;
  clearSelection?: boolean;
};

export const FaqMenu = ({ onSelectTopic, clearSelection }: FaqMenuProps): ReactElement => {
  const [selected, setSelected] = useState<string | null>(null);

  function handleSelection(content: FaqContent) {
    setSelected(content.card.title);
    onSelectTopic(content);
  }

  function handleHover(content: FaqContent, active: boolean) {
    setSelected((current) => {
      if (active) {
        return content.card.title;
      }
      return current === content.card.title ? null : current;
    });
  }

  useEffect(() => {
    setSelected(null);
  }, [clearSelection]);

  return (
    <div style={styles.list}>
      {faqContent.map((content) => (
        <SelectableCard
          isSelected={content.card.title === selected}
          variant="button"
          key={content.card.title}
          icon={content.card.icon}
          title={content.card.title}
          description={content.card.description}
          onClick={() => handleSelection(content)}
          onHover={(active) => handleHover(content, active)}
        />
      ))}
      <SelectableCard
        variant="link"
        isSelected={CONTACT_CARD_CONTENT.card.title === selected}
        key={CONTACT_CARD_CONTENT.card.title}
        icon={CONTACT_CARD_CONTENT.card.icon}
        title={CONTACT_CARD_CONTENT.card.title}
        description={CONTACT_CARD_CONTENT.card.description}
        to={{ pathname: '/support', search: `tipo=${CONTACT_CARD_REQUEST_TYPE}` }}
        onHover={(active) => handleHover(CONTACT_CARD_CONTENT, active)}
      />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  list: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(${tokens.dimensions.faqCardMinWidth}px, 1fr))`,
    gap: tokens.spacing.small,
  },
};
